// @flow
import {
  GTM_ACCOUNTS_UPDATED,
  GTM_ACCOUNTS_UPDATING,
  GTM_ACCOUNTS_FETCH_ERROR,
  CONTAINERS_UPDATED,
  CONTAINERS_UPDATING,
  CONTAINERS_FETCH_ERROR,
  WORKSPACES_UPDATED,
  WORKSPACES_UPDATING,
  WORKSPACES_FETCH_ERROR,
  UA_CODES_UPDATED,
  UA_CODES_UPDATING,
  UA_CODES_FETCH_ERROR
} from '../actions/gtmapi.actions';

import {
  SUMMARY_UPDATED,
  SUMMARY_UPDATING,
  SUMMARY_EMPTY_ERROR,
  SUMMARY_FETCH_ERROR,
  GTM_SAVING,
  GTM_SAVED
} from '../actions/project.actions';

const initialState = {
  gtmAccountsUpdating: false,
  gtmAccountsError: null,
  gtmAccounts: [],
  containersUpdating: false,
  containersError: null,
  containers: [],
  workspacesUpdating: false,
  workspacesError: null,
  workspaces: [],
  uaCodes: [],
  uaCodesUpdating: false,
  uaCodesError: null,
  summary: [],
  summaryUpdating: false,
  summaryError: null,
  isMatch: false,
  matched: [],
  gtmSaving: false
};

export default (state: Object = initialState, action: { type: String, data: Object }) => {
  switch (action.type) {
    case GTM_SAVING:
      return {
        ...state,
        gtmSaving: true
      };
    case GTM_SAVED:
      return {
        ...state,
        gtmSaving: false
      };
    case UA_CODES_UPDATING:
      return {
        ...state,
        uaCodes: [],
        uaCodesUpdating: true
      };

    case UA_CODES_UPDATED:
      return getMatched({
        ...state,
        uaCodes: action.data,
        uaCodesUpdating: false
      });
    case UA_CODES_FETCH_ERROR:
      return getMatched({
        ...state,
        uaCodes: [],
        uaCodesUpdating: false
      });
    case SUMMARY_UPDATING:
      return {
        ...state,
        summary: [],
        summaryUpdating: true
      };

    case SUMMARY_UPDATED:
      return getMatched({
        ...state,
        summary: action.data,
        summaryUpdatingError: false,
        summaryEmptyError: false,
        summaryUpdating: false
      });

    case SUMMARY_EMPTY_ERROR:
      return getMatched({
        ...state,
        summary: [],
        summaryUpdatingError: false,
        summaryEmptyError: true,
        summaryUpdating: false
      });

    case SUMMARY_FETCH_ERROR:
      return getMatched({
        ...state,
        summary: [],
        summaryUpdatingError: true,
        summaryEmptyError: false,
        summaryUpdating: false
      });

    case GTM_ACCOUNTS_UPDATING:
      return {
        ...state,
        gtmAccounts: [],
        workspaces: [],
        containers: [],
        gtmAccountsError: null,
        gtmAccountsUpdating: true
      };
    case GTM_ACCOUNTS_FETCH_ERROR:
      return {
        ...state,
        ...action.data,
        gtmAccountsError: true,
        gtmAccountsUpdating: false
      };
    case GTM_ACCOUNTS_UPDATED:
      return {
        ...state,
        gtmAccounts: action.data,
        gtmAccountsError: null,
        gtmAccountsUpdating: false
      };
    case CONTAINERS_UPDATING:
      return {
        ...state,
        containers: [],
        workspaces: [],
        containersError: null,
        containersUpdating: true
      };
    case CONTAINERS_FETCH_ERROR:
      return {
        ...state,
        ...action.data,
        containersError: true,
        containersUpdating: false
      };
    case CONTAINERS_UPDATED:
      return {
        ...state,
        containers: action.data,
        containersError: null,
        containersUpdating: false
      };
    case WORKSPACES_UPDATING:
      return {
        ...state,
        workspaces: [],
        workspacesError: null,
        workspacesUpdating: true
      };
    case WORKSPACES_FETCH_ERROR:
      return {
        ...state,
        ...action.data,
        workspacesError: true,
        workspacesUpdating: false
      };
    case WORKSPACES_UPDATED:
      return {
        ...state,
        workspaces: action.data,
        workspacesError: null,
        workspacesUpdating: false
      };
    default:
      return state;
  }
};

function getMatched(state) {
  const { uaCodesUpdating, summaryUpdating, uaCodes, summary } = state;
  if (uaCodesUpdating || summaryUpdating || uaCodes.length === 0 || summary.length === 0)
    return { ...state };
  const flatWebProperties = summary.reduce(
    (res, acc) =>
      res.concat(
        !acc.webProperties
          ? []
          : acc.webProperties.map((wp) =>
              Object.assign({}, wp, { accountId: acc.id, accountName: acc.name })
            )
      ),
    []
  );
  const matchedWebProperties = flatWebProperties.filter((wp) => !!~uaCodes.indexOf(wp.id));
  if (matchedWebProperties.length > 0)
    return { ...state, isMatch: true, matched: matchedWebProperties };
  return { ...state };
}



// WEBPACK FOOTER //
// ./src/reducers/gtmReducer.js